{
  "form": {
    "input_placeholder": "أضف مهمة…",
    "parseWithAi_aria": "تحليل المهمة بالذكاء الاصطناعي",
    "parseWithAi_title": "تنظيم المهمة وتحديد أولويتها بالذكاء الاصطناعي",
    "priorityLabel_aria": "أولوية المهمة",
    "add": "إضافة",
    "signInForAi": "سجّل الدخول لاستخدام ميزات الذكاء الاصطناعي.",
    "aiUnavailable": "الذكاء الاصطناعي غير متاح. حاول مجددًا.",
    "saveTo": "حفظ في",
    "saveTo_aria": "حفظ في {{list}}",
    "saveToSynced_aria": "حفظ في {{list}}، {{provider}}",
    "addedTo": "أُضيف إلى {{list}}",
    "addedToSynced": "أُضيف إلى {{list}} · {{provider}}",
    "show": "عرض"
  },
  "priority": {
    "Critical": "حرجة",
    "High": "عالية",
    "Medium": "متوسطة",
    "Low": "منخفضة"
  },
  "item": {
    "edit_aria": "تعديل المهمة",
    "delete_aria": "حذف المهمة",
    "addStep": "أضف خطوة",
    "addStep_placeholder": "أضف خطوة…",
    "addStep_aria": "أضف خطوة إلى {{task}}",
    "steps_group_aria": "خطوات {{task}}",
    "steps_progress_aria": "اكتملت {{done}} من {{count}} خطوات",
    "completeSteps_aria": "{{task}}. ستكتمل أيضًا {{count}} خطوات مفتوحة"
  },
  "list": {
    "title": "المهام",
    "newListFallback": "قائمة جديدة",
    "completedMeta": "اكتمل {{completed}} من {{total}}",
    "deleteConfirm": "حذف \"{{name}}\"؟",
    "rename_title": "إعادة تسمية",
    "deleteList_title": "حذف القائمة",
    "newListName_placeholder": "اسم القائمة…",
    "newList": "قائمة جديدة",
    "done": "تم",
    "emptyTitle": "لا توجد مهام بعد",
    "emptySubtitle": "أضف مهمة أدناه للبدء.",
    "noFilterMatch": "لا توجد مهام تطابق هذا المرشّح.",
    "createIn": "إنشاء في",
    "inDestination": "في {{destination}}",
    "createIn_aria": "إنشاء في {{destination}}",
    "createInAccount_aria": "إنشاء في {{destination}}، {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "جارٍ الإنشاء في {{destination}}…",
    "createFailed": "تعذّر إنشاء «{{name}}» في {{destination}}.",
    "createLimit": "بلغ {{destination}} الحد الأقصى للقوائم.",
    "keepInRhemn": "الإبقاء في Rhemn"
  },
  "filter": {
    "label": "تصفية",
    "all": "الكل"
  },
  "voice": {
    "mic_aria": "إضافة مهام بالصوت",
    "mic_title": "انطق مهامك — تُرتَّب حسب الأولوية والوقت",
    "stop_aria": "إيقاف وترتيب المهام",
    "recording": "جارٍ التسجيل",
    "sorting": "جارٍ ترتيب مهامك…",
    "stripTitle": "المهام المسموعة",
    "stripCount": "{{checked}} من {{total}}",
    "discard": "تجاهل",
    "addN": "إضافة {{count}}",
    "addZero": "إضافة",
    "adding": "جارٍ الإضافة…",
    "parseFallback": "تعذّر الترتيب — كلماتك في الحقل.",
    "nothingHeard": "لم يُسمع شيء — حاول مجددًا.",
    "micDenied": "الميكروفون محظور — اسمح به من الإعدادات.",
    "gateBody": "انطق مهامك — تُرتَّب حسب الأولوية وفترة الصلاة. ضمن اشتراك Pro.",
    "listen_aria": "يستمع — انطق مهامك"
  }
}
